module.exports = __webpack_public_path__ + "static/media/building.702f604f.svg";